// extracted by mini-css-extract-plugin
module.exports = {"container":"Section_container__t9xgY","hero":"Section_hero__wnIlD","article":"Section_article__1vSod","overlay":"Section_overlay__LwLUo"};